export default function AIAnswerBlock() {
  return (
    <section className="bg-[#111113] border-y border-[#2a2a2c] py-20 px-4 md:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-8 h-px bg-[#D4AF37]"></div>
          <span className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase">About the Company</span>
        </div>

        <h2
          className="text-white font-bold text-3xl md:text-4xl mb-8"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          About Exclusive Recovery Inc
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-[#b8b8b8] text-base leading-relaxed">
          <div>
            <h3 className="text-white font-semibold text-lg mb-2">What We Do</h3>
            <p>
              Exclusive Recovery Inc, operating publicly as Exclusive Towing, provides professional towing, vehicle transport, and recovery services throughout Riverside and the broader Inland Empire region of Southern California. Founded in 1991, the company operates 24 hours a day, 365 days a year.
            </p>
          </div>
          <div>
            <h3 className="text-white font-semibold text-lg mb-2">Who We Serve</h3>
            <p>
              The company serves the general public, commercial fleet operators, private property owners, lenders, and state and local law enforcement agencies. Exclusive Towing holds municipal contracts with the City of Riverside and the City of Moreno Valley.
            </p>
          </div>
          <div>
            <h3 className="text-white font-semibold text-lg mb-2">Core Services</h3>
            <ul className="space-y-1">
              {[
                "Towing & Transport (standard and heavy-duty)",
                "Vehicle Recovery",
                "Heavy Equipment & Specialty Transport",
                "Impound & Secure Storage",
                "Roadside Assistance",
                "Law Enforcement & Municipal Towing",
                "Private Property Impound Management",
              ].map((s, i) => (
                <li key={i} className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                    <i className="ri-checkbox-circle-line text-[#D4AF37] text-sm"></i>
                  </div>
                  {s}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="mb-6">
              <h3 className="text-white font-semibold text-lg mb-2">Service Area</h3>
              <p>
                Headquartered at 3777 Placentia Lane, Riverside, CA 92501, with an additional facility in Moreno Valley. Serving Riverside, Moreno Valley, Colton, San Bernardino County, and surrounding Inland Empire communities.
              </p>
            </div>
            <div>
              <h3 className="text-white font-semibold text-lg mb-2">Why Clients Trust Us</h3>
              <p>
                Family-owned and operated since 1991. Holds active municipal contracts with the City of Riverside and City of Moreno Valley. Operates secure impound facilities with 24-hour surveillance. Works directly with state and local law enforcement agencies across Southern California.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
